import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  Button,
  Text,
  useColorModeValue,
  Heading,
  ModalHeader,
  ModalCloseButton,
  Stack,
  HStack,
  VStack,
  Box,
  Divider,
  Select,
  FormControl,
  FormLabel
} from "@chakra-ui/react";
import { COLORS } from "../../../constants/colors";
import { useContext, useEffect, useState, useCallback } from "react";
import { UserProfileContext } from "../../../context/userProfileContext";
import { AuthContext } from "../../../context/authContext";
import { useNavigate } from "react-router-dom";
import { PROTECTED_PATHS } from "../../../app/constants";
import {
  getEstateDue,
  getEstateInfo,
  initializePayment,
  verifyEstateDuePayment
} from "../../estateDue/service";
import {
  infoNotifier,
  errorNotifier,
  successNotifier
} from "../../../components/NotificationHandler";
import axiosInstance from "../../../services/api";

export const ConfirmPaymentModal = ({ dueTypes, totalPendingAmount }) => {
  const bgColor = useColorModeValue(COLORS.primary, COLORS.green);
  const cardBg = useColorModeValue(COLORS.lightGrey, COLORS.white);
  const btnBg = useColorModeValue(COLORS.lightGrey, COLORS.green);
  const btnColor = useColorModeValue(COLORS.green, COLORS.white);
  const [isLoading, setIsLoading] = useState(false);
  const { userProfile } = useContext(UserProfileContext);
  const { tenantName, email } = userProfile;
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const [estateDue, setEstateDue] = useState([]);
  const [estateInfo, setEstateInfo] = useState([]);
  const [monthsAhead, setMonthsAhead] = useState(1);
  const [paymentData, setPaymentData] = useState({});
  const [paymentModal, setPaymentModal] = useState(false);
  const [transactionCharge, setTransactionCharge] = useState(0);
  const navigate = useNavigate();
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [ninePaymentModal, setNinePaymentModal] = useState(false);
  const [ninePaymentData, setNinePaymentData] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const { MY_WALLET } = PROTECTED_PATHS;

  useEffect(() => {
    const fixedCharge = 100;
    const charges = 0.015 * dueTypes?.amount;
    if (dueTypes?.amount < 2000) {
      setTransactionCharge(charges);
      return;
    } else if (charges >= 2000) {
      setTransactionCharge(2000 + fixedCharge);
      return;
    } else {
      setTransactionCharge(charges + fixedCharge);
    }
  }, [dueTypes?.amount]);

  useEffect(() => {
    getEstateDue(userId, setIsLoading, setEstateDue);
    getEstateInfo(userId, setIsLoading, setEstateInfo);
  }, [userId]);

  const payEstateDue = () => {
    const payload = {
      amount: dueTypes?.amount + transactionCharge + totalPendingAmount,
      tenantName,
      email,
      userId,
      duration: monthsAhead,
      dueTypeId: dueTypes?._id,
      month: selectedMonth,
      year: selectedYear,
      totalPendingAmount: totalPendingAmount
    };

    console.log(payload, "payload");
    console.log(dueTypes, "duetypess");

    if (!payload.email) {
      infoNotifier("please set your profile and add your Email first ");
      return;
    }

    initializePayment(payload, setIsLoading, setPaymentData, setPaymentModal);
    // Call verifyPayments after initializing payment
    setPaymentModal(true); // Open modal here
  };

  const handlePayment = async () => {
    try {
      setPaymentLoading(true);
      const res = await axiosInstance.post("/request-9psb", {
        amount: dueTypes?.amount + transactionCharge,
        tenantName,
        email,
        userId,
        duration: monthsAhead,
        dueTypeId: dueTypes?._id,
        month: selectedMonth,
        year: selectedYear
      });

      const paymentInfo = res?.data;
      const tnxRef =
        paymentInfo?.data?.transactionReference ||
        paymentInfo?.result?.data?.transactionReference;
      if (tnxRef) {
        localStorage.setItem("Due-tnx", tnxRef);
      }

      // Extract payment data from response (supports both data and result formats)
      const accountData = paymentInfo?.data || paymentInfo?.result;
      
      if (accountData && accountData?.data) {
        // Show modal with payment information instead of redirecting
        setNinePaymentData(accountData);
        onClose();
        setNinePaymentModal(true);
        successNotifier("Virtual account created! Please review the details.");
      } else {
        throw new Error("Virtual account details not found in response.");
      }
    } catch (error) {
      console.error("9PSB payment error:", error);
      errorNotifier(
        error?.response?.data?.message ||
        error?.response?.data?.result?.message ||
        error.message ||
        "Payment failed. Please try again."
      );
    } finally {
      setPaymentLoading(false);
    }
  };

  const verifyPayments = () => {
    const payload = {
      userId,
      reference: paymentData?.reference,
      type: "paystack"
    };

    verifyEstateDuePayment(payload, navigate);
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const paymentChannel = "9psb"; //paystack or 9psb or both

  return (
    <>
      <Button
        bg={btnBg}
        color={btnColor}
        onClick={onOpen}
        _hover={{ backgroundColor: `${btnBg}` }}
      >
        Pay Now
      </Button>
      <Modal
        size="sm"
        isOpen={isOpen}
        onClose={onClose}
        trapFocus={false}
        blockScrollOnMount={false}
      >
        <ModalOverlay />
        <ModalContent py="50px" bg={COLORS.white}>
          <ModalBody>
            <Heading fontSize="20px" color={COLORS.green} pb="30px">
              Choose Payment Method
            </Heading>

            {paymentChannel === "paystack" ? (
              <>
                <Text >
                  Kindly select your preferred payment method. You'll be
                  receiving an acknowledgement via Email/SMS.
                </Text>
                <Button
                  w={"100%"}
                  mt="50px"
                  bg={bgColor}
                  color={cardBg}
                  _hover={{ backgroundColor: `${bgColor}` }}
                  isLoading={isLoading}
                  onClick={payEstateDue}
                >
                  Pay with Paystack
                </Button>
                <Modal
                  isOpen={paymentModal}
                  onClose={onClose} // Close modal without verification
                  isCentered
                  bg="red"
                  size="sm"
                  trapFocus={false}
                >
                  <ModalOverlay />
                  <ModalContent bg={"white"}>
                    <ModalHeader>Payment checkout</ModalHeader>
                    <ModalCloseButton onClick={verifyPayments} />{" "}
                    <Stack pb="4" pt="2" pl="7%" fontWeight="500">
                      <HStack fontWeight={600} fontSize="12px">
                        <Text pr="2">
                          {dueTypes?.type}: &#8358;{" "}
                          {dueTypes?.amount?.toLocaleString()}
                        </Text>
                        <Text>
                          Paystack Charge: &#8358;{" "}
                          {transactionCharge?.toLocaleString()}{" "}
                        </Text>
                      </HStack>
                      {totalPendingAmount > 0 && (
                        <Text fontWeight={600} fontSize="12px">
                          Total Pending Amount: &#8358;{" "}
                          {totalPendingAmount?.toLocaleString()}
                        </Text>
                      )}
                      <Text fontWeight={600} fontSize="12px">
                        Total: &#8358;{" "}
                        {(
                          transactionCharge + dueTypes?.amount + (totalPendingAmount > 0 ? totalPendingAmount : 0)
                        )?.toLocaleString()}
                      </Text>
                    </Stack>
                    <ModalBody p="0">
                      <iframe
                        src={paymentData?.authorization_url}
                        width="100%"
                        height="450"
                        title="payment checkout"
                      ></iframe>
                    </ModalBody>
                  </ModalContent>
                </Modal>
              </>
            ) : paymentChannel === "9psb" ? (
              <Stack>
                <Text>
                  Kindly click the button below to generate your transfer
                  account details. You'll be receiving an acknowledgement via
                  Email/SMS once payment is confirmed.
                </Text>

                {/* Duration Selector - Year is always required, Month only for monthly frequency */}
                <Stack spacing={3} mt={4}>
                  {dueTypes?.frequency === "monthly" && (
                    <FormControl>
                      <FormLabel fontSize="14px" fontWeight="600">
                        Select Month
                      </FormLabel>
                      <Select
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        bg={COLORS.lightGrey}
                        focusBorderColor={COLORS.green}
                        placeholder="Select Month"
                      >
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                      </Select>
                    </FormControl>
                  )}

                  <FormControl>
                    <FormLabel fontSize="14px" fontWeight="600">
                      Select Year
                    </FormLabel>
                    <Select
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                      bg={COLORS.lightGrey}
                      focusBorderColor={COLORS.green}
                      placeholder="Select Year"
                    >
                      {Array.from({ length: 10 }, (_, i) => {
                        const year = new Date().getFullYear() - i;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Stack>

                {/* Amount Breakdown */}
                <VStack spacing={3} mt={4}>
                  <HStack
                    fontWeight={600}
                    fontSize="14px"
                    w="100%"
                    justify="space-between"
                  >
                    <Text>{dueTypes?.type}:</Text>
                    <Text>&#8358; {dueTypes?.amount?.toLocaleString()}</Text>
                  </HStack>
                  <HStack
                    fontWeight={600}
                    fontSize="14px"
                    w="100%"
                    justify="space-between"
                  >
                    <Text>Transaction Charge:</Text>
                    <Text>&#8358; {transactionCharge?.toLocaleString()}</Text>
                  </HStack>
                  {totalPendingAmount > 0 && (
                    <HStack
                      fontWeight={600}
                      fontSize="14px"
                      w="100%"
                      justify="space-between"
                    >
                      <Text>Pending Amount:</Text>
                      <Text>
                        &#8358; {totalPendingAmount?.toLocaleString()}
                      </Text>
                    </HStack>
                  )}
                  <Divider />
                  <HStack
                    fontWeight={700}
                    fontSize="16px"
                    w="100%"
                    justify="space-between"
                    color={COLORS.green}
                  >
                    <Text>Total:</Text>
                    <Text>
                      &#8358;{" "}
                      {(
                        transactionCharge +
                        dueTypes?.amount +
                        (totalPendingAmount > 0 ? totalPendingAmount : 0)
                      )?.toLocaleString()}
                    </Text>
                  </HStack>
                </VStack>

                <Button
                  w={"100%"}
                  mt="30px"
                  bg={"#87B61C"}
                  color={COLORS.white}
                  _hover={{ opacity: 0.85, background: "#28724F" }}
                  isLoading={paymentLoading}
                  isDisabled={
                    paymentLoading ||
                    (dueTypes?.frequency === "monthly"
                      ? !selectedMonth || !selectedYear
                      : !selectedYear)
                  }
                  onClick={handlePayment}
                >
                  {paymentLoading ? "Processing..." : "Pay with 9PSB (Transfer)"}
                </Button>
              </Stack>
            ) : (
              <Stack>
                <Text fontSize={"1rem"}>
                  Kindly select your preferred payment method.
                </Text>
                <Text mb="4" fontWeight="bold">
                  Note: Use Paystack to pay with card, or 9PSB to pay with transfer.
                </Text>
                <Button
                  w={"100%"}
                  mt="50px"
                  bg={"#87B61C"}
                  color={COLORS.white}
                  _hover={{ opacity: 0.85, background: "#28724F" }}
                  isLoading={paymentLoading}
                  isDisabled={paymentLoading}
                  onClick={handlePayment}
                >
                  {paymentLoading ? "Processing..." : "Pay with 9PSB (Transfer)"}
                </Button>

                <Button
                  w={"100%"}
                  mt="20px"
                  bg={bgColor}
                  color={cardBg}
                  _hover={{ backgroundColor: `${bgColor}` }}
                  isLoading={isLoading}
                  onClick={payEstateDue}
                >
                  Pay with Paystack
                </Button>
                <Modal
                  isOpen={paymentModal} 
                  onClose={onClose} // Close modal without verification
                  isCentered
                  bg="red"
                  size="sm"
                  trapFocus={false}
                >
                  <ModalOverlay />
                  <ModalContent bg={"white"}>
                    <ModalHeader>Payment checkout</ModalHeader>
                    <ModalCloseButton onClick={verifyPayments} />{" "}
                    <Stack pb="4" pt="2" pl="7%" fontWeight="500">
                      <HStack fontWeight={600} fontSize="12px">
                        <Text pr="2">
                          {dueTypes?.type}: &#8358;{" "}
                          {dueTypes?.amount?.toLocaleString()}
                        </Text>
                        <Text>
                          Paystack Charge: &#8358;{" "}
                          {transactionCharge?.toLocaleString()}{" "}
                        </Text>
                      </HStack>
                      {totalPendingAmount > 0 && (
                        <Text fontWeight={600} fontSize="12px">
                          Total Pending Amount: &#8358;{" "}
                          {totalPendingAmount?.toLocaleString()}
                        </Text>
                      )}
                      <Text fontWeight={600} fontSize="12px">
                        Total: &#8358;{" "}
                        {(
                          transactionCharge + dueTypes?.amount + (totalPendingAmount > 0 ? totalPendingAmount : 0)
                        )?.toLocaleString()}
                      </Text>
                    </Stack>
                    <ModalBody p="0">
                      <iframe
                        src={paymentData?.authorization_url}
                        width="100%"
                        height="450"
                        title="payment checkout"
                      ></iframe>
                    </ModalBody>
                  </ModalContent>
                </Modal>
              </Stack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
